import { render, staticRenderFns } from "./MyBuild.vue?vue&type=template&id=11916346&scoped=true"
import script from "./MyBuild.vue?vue&type=script&lang=js"
export * from "./MyBuild.vue?vue&type=script&lang=js"
import style0 from "./MyBuild.vue?vue&type=style&index=0&id=11916346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11916346",
  null
  
)

export default component.exports